import { render, staticRenderFns } from "./CompanyPageView.vue?vue&type=template&id=1716de1e&"
import script from "./CompanyPageView.vue?vue&type=script&lang=ts&"
export * from "./CompanyPageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports